import { makeStyles } from '@material-ui/core/styles';
import tw from 'twin.macro';

export const useAutocompleteStyles = makeStyles(() => ({
  root: (props) => ({
    '&': {
      ...(props.doAddBorderInRoot ? { ...tw`h-full border` } : { ...tw`h-full` }),
      ...(props.withLeftRadius ? { ...tw`rounded-l-2xl` } : {}),
      ...(props.withRightRadius ? { ...tw`rounded-r-xl` } : {}),
      height: props.minHeight,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"]': {
      ...tw`py-0 px-6 absolute z-10`,
      ...(props.withRightRadius ? tw`rounded-r-xl` : { borderRadius: 0 }),
      ...(props.withLeftRadius ? tw`rounded-l-2xl` : { borderRadius: 0 }),
      'min-height': props.minHeight,
    },
    '& .MuiFilledInput-underline:before': tw`border-0`,
    '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"] .MuiAutocomplete-input': {
      ...(props.noPaddingTop ? { ...tw`py-0` } : { ...tw`py-3` }),
      'min-height': props.minHeight || '26px',
    },
    '& .MuiFilledInput-root.Mui-focused': { backgroundColor: props.bgColor || 'white' },
    '& .MuiFilledInput-underline:after': tw`border-0`,
    '& .MuiFormControl-root.MuiTextField-root': {
      ...(props.withLeftRadius ? tw`rounded-l-2xl` : {}),
      ...(props.withRightRadius ? tw`rounded-r-xl` : {}),
    },
  }),
  input: (props) => ({
    '&': {
      ...tw`flex items-center relative border border-gray-500 border-opacity-10 px-2 bg-white w-full h-full`,
      'font-family': 'var(--fontFamilyBody)',
      backgroundColor: props.bgColor || 'white',
    },
    '&::placeholder': { ...tw`placeholder-gray-500`['::placeholder'], opacity: '1' },
    '&:before': tw`border-0`,
  }),
  inputRoot: (props) => ({
    '&:hover, &:focus, &:active': { backgroundColor: props.bgColor || 'white' },
    '&': {
      ...tw`py-3`,
      'font-family': 'var(--fontFamilyBody)',
      backgroundColor: props.bgColor || 'white',
    },
  }),
  focused: (props) => ({ backgroundColor: props.bgColor || 'white' }),
  paper: {
    marginTop: 'unset',
    borderTopLeftRadius: 'unset',
    borderTopRightRadius: 'unset',
  },
}));
export const usePickerClasses = makeStyles(() => ({
  dateRangePicker: {
    '& div[class*="header"]': {
      display: 'none',
    },
    '& button[class*="materialui-daterange-picker-makeStyles-filled-"]': {
      backgroundColor: 'rgba(var(--background))',
    },
    '&': {
      zIndex: '11',
    },
  },
}));
